import React from 'react'

export default () => (
  <section id="numbers">
    <div className="section_title">
      <p>NUMBERS</p>
      <h2>数字で見るソルパック</h2>
    </div>
    <div className="section_contents">
      <div className="numbers_contents">
        <div className="numbers_item"><img src="images/numbers/numbers01.jpg" alt="" /></div>
        <div className="numbers_item"><img src="images/numbers/numbers02.jpg" alt="" /></div>
        <div className="numbers_item"><img src="images/numbers/numbers03.jpg" alt="" /></div>
        <div className="numbers_item"><img src="images/numbers/numbers04.jpg" alt="" /></div>
        <div className="numbers_item"><img src="images/numbers/numbers05.jpg" alt="" /></div>
        <div className="numbers_item"><img src="images/numbers/numbers06.jpg" alt="" /></div>
        <div className="numbers_item"><img src="images/numbers/numbers07.jpg" alt="" /></div>
      </div>
    </div>
  </section>
)


// WEBPACK FOOTER //
// ./src/Home/Numbers/Container.js